module.exports = __webpack_public_path__ + "img/google09.6a5d82cb.jpg";